// extracted by mini-css-extract-plugin
module.exports = {"Table":"PayoutsTable_Table__1eP5J","HeadCell":"PayoutsTable_HeadCell__3fiK4","Cell":"PayoutsTable_Cell__3Aba2","Row":"PayoutsTable_Row__T46LR"};